import styled from 'styled-components';
export const StyledSearchForm = styled.form.withConfig({
  displayName: "StyledSearchForm",
  componentId: "sc-1n24b7v-0"
})(["display:block !important;overflow:hidden;position:", ";top:", ";left:", ";z-index:2;width:", ";"], ({
  isOpen
}) => isOpen ? 'absolute' : 'relative', ({
  theme,
  isOpen
}) => isOpen && theme.space['400'], ({
  theme,
  isOpen
}) => isOpen && theme.space['600'], ({
  isOpen
}) => isOpen ? '515px' : '100%');